import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons'
import { faSquare } from '@fortawesome/free-regular-svg-icons'

import './QbCheckbox.css'

const QbCheckbox = ({ style, checked, onChange }) => (
  <div className="qb-checkbox-container" style={style} onClick={() => onChange()}>
    <FontAwesomeIcon
      style={ICON_STYLE}
      icon={checked ? faCheckSquare : faSquare}
    />
  </div>
)

export default QbCheckbox

const ICON_STYLE = {
  width: '16px', 
  height: '18px',  
}



// WEBPACK FOOTER //
// ./src/components/shared/QbCheckbox/QbCheckbox.js